/* eslint-disable */
<template>
  <v-container>
    <v-layout>
      <v-flex  class="text-xs-center pb-3">
        <h1>Tell Us a Little About Yourself</h1>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="text-xs-center pb-3">
        <v-btn
          large
          router to="/getstudentinfo"
          dark class="yellow darken-4"
          v-if="userIsAuthenticated"
          flat
          @click="userIsStudent">
          Student
        </v-btn>
        <v-btn
          large
          router to="/getlabinfo"
          dark class="yellow darken-4"
          v-if="userIsAuthenticated"
          flat
          @click="userIsEmployer">
          Lab Member
        </v-btn>
      </v-flex>
  </v-layout>

<br>
<br>

  <v-layout row>
    <v-flex xs5>
    <v-card dark class="yellow darken-4">
      <v-card-text class="px-0, text-xs-justify pb-3">

          Select this option if you are an undergraduate student, looking for a research position.

      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs5 offset-xs2>
  <v-card dark class="yellow darken-4">
    <v-card-text class="px-0, text-xs-justify pb-3">

          Select this option if you are a lab coordinator, with the ability to post openings.

    </v-card-text>
  </v-card>
</v-flex>

      </v-layout>
  </v-container>

</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    userIsStudent () {
      // this.$store.dispatch('userIsStudent')
      this.$router.push('/getstudentinfo')
    },
    userIsEmployer () {
      // this.$store.dispatch('userIsEmployer')
      this.$router.push('/getlabinfo')
    }

  }
}
</script>
